import { c as _c } from "react/compiler-runtime";
import { Stack, Typography, Divider, Box } from '@mui/material';
import { Provider } from '@repo/api-gw-sdk';
import { BulletItem } from '@/app/(blank-layout-pages)/(authenticated)/onboarding/bulletItem';
import { NumericBulletSection } from '@/app/(blank-layout-pages)/(authenticated)/onboarding/numericBulletSection';
import type { BackupVault } from '@/data/vaults/backupVault';
import { getDocsUrl } from '@/docs/docsUrls';
import { KmsCopyablePolicy } from './kmsCopyablePolicy';
import { KmsEditKeyPolicyButton } from './kmsEditKeyPolicyButton';
import { BottomDialog } from '../dialogs/bottomDialog';
import { FormTextField } from '../form/formTextField';
import { getCloudFieldConfig } from '../form/validation/cloudFieldValidation';
import { PanelWrapper } from '../panels/panelWrapper';
import { ReadMoreLink } from '../shared/readMoreLink';
const KmsKeyDescription = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="body1" component="span">Set the KMS key to encrypt snapshots with. You’re responsible for securing the key from unauthorized access and deletion. Without this key, snapshots can’t be retrieved from the vault.{" "}<ReadMoreLink href={getDocsUrl("vaultSelfManagedKeys")} /></Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const kmsKeyArnConfig = getCloudFieldConfig(Provider.Aws, 'kmsKeyArn');
export const KMSKeyEditorPanel = t0 => {
  const $ = _c(28);
  const {
    open,
    onClose,
    data,
    setData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <KmsKeyDescription />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] !== onClose) {
    t2 = {
      title: "Set KMS Key",
      subtitle: t1,
      fullWidthSubtitle: false,
      onClose
    };
    t3 = {
      primaryButton: {
        text: "Done",
        "data-testid": "done-button",
        onClick: onClose
      },
      secondaryButton: {
        text: "Cancel",
        "data-testid": "cancel-button",
        onClick: onClose
      }
    };
    $[1] = onClose;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Divider sx={{
      borderStyle: "dashed"
    }} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = data.vaultAttributes.aws?.encryptionKey ?? "";
  let t6;
  if ($[5] !== data || $[6] !== setData) {
    t6 = event => {
      setData({
        ...data,
        vaultAttributes: {
          ...data.vaultAttributes,
          aws: {
            ...data.vaultAttributes.aws,
            encryptionKey: event.target.value
          }
        }
      });
    };
    $[5] = data;
    $[6] = setData;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <NumericBulletSection bulletNumber={1} title="Set key details"><BulletItem leftContent={<FormTextField title="KMS key ARN" placeholder={kmsKeyArnConfig.placeholder} value={t5} onChange={t6} validation={kmsKeyArnConfig.validation} />} /></NumericBulletSection>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = data.vaultAttributes.aws?.encryptionKey;
  let t9;
  if ($[11] !== t8) {
    t9 = <KmsEditKeyPolicyButton kmsKey={t8} />;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== data.vaultAttributes.cloudProvider) {
    t10 = <KmsCopyablePolicy cloudProvider={data.vaultAttributes.cloudProvider} />;
    $[13] = data.vaultAttributes.cloudProvider;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <NumericBulletSection bulletNumber={2} title="Add policy in AWS"><BulletItem title="Review and add this policy in your AWS account. Afterward, come back to this tab to finish the connection." leftContent={t9} rightContent={t10} /></NumericBulletSection>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t7) {
    t12 = <Box padding="40px min(100px,6vw)" width="100%" height="auto"><Stack gap="40px" divider={t4}>{t7}{t11}</Stack></Box>;
    $[18] = t11;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t2 || $[23] !== t3) {
    t13 = <PanelWrapper header={t2} footer={t3}>{t12}</PanelWrapper>;
    $[21] = t12;
    $[22] = t2;
    $[23] = t3;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== open || $[26] !== t13) {
    t14 = <BottomDialog open={open} isFullScreen={true}>{t13}</BottomDialog>;
    $[25] = open;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};